import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import { cargarCatalogosAsync, cargarCatalogosGenericoAsync, cargarCatalogos } from '../../funciones_globales/catalogos';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import ReactSelectAsync from '../componentes_generales/componentes_formulario/selects/react-select-async';
import ReactSelect from '../componentes_generales/componentes_formulario/selects/react-select';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';

class FormInven07  extends React.Component{
    constructor(props){
        super(props);
        this.state = {            
            fechaDesde: null,
            fechaHasta: null,

            bodega_sel: null,
            bodega_opt: [],
            linea_sel: null,
            articulo_desde_sel: null,
            articulo_hasta_sel: null,

            valorizado: false,
        };
        
        this.changeComponents = this.changeComponents.bind(this);
        this.changeYear = this.changeYear.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.impKardexPorArticulo = this.impKardexPorArticulo.bind(this);
        this.cambiarValoresInput = this.cambiarValoresInput.bind(this);
    }

    changeComponents(event){

        const target = event.target;       
        const name = target.name; 
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        
        this.setState({[name]: value});
    }

    changeYear(){
        if(this.state.periodo!==''){
            var anio = parseInt(this.state.periodo,10)
            var fechaInf = parseInt(this.state.anioActual,10) - 3;

            if(anio>parseInt(this.state.anioActual,10)){
                this.setState({periodo: parseInt(this.state.anioActual,10)});
            }else if(anio===parseInt(this.state.anioActual,10)){
                this.setState({periodo: anio});
            }else if(anio >= fechaInf && anio <=parseInt(this.state.anioActual,10)){
                this.setState({periodo: anio});
            }else{
                this.setState({periodo: parseInt(this.state.anioActual,10)});
                alert("Rango incorrecto para el periodo, máximo 3 años hacia atrás")
            }
        }
    }
    
    getOptions_Proveedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '&cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/proveedores?tipo=catalogo', cadena_busq, callback)
        }
    }

    getOptions_Articulos(input, callback){
        if (input.toString().length >= 2 ){
            let query = "?tipo=catalogo&cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/articulos', query, callback)
        }
    }

    getOptions_Marcas(input, callback){
        if (input.toString().length >= 2 ){
          cargarCatalogosAsync('LINEA', input, callback)
        }
    }

    componentDidMount(){
        Promise.all([
            cargarCatalogos('BODEGA'),                
            this.props.generar_LogAuditoriaIngresoForm('0207')
         ])
        .then(([ bodega ]) => {
            let fechaProceso = getFechaProcesoPorModulo('02');
            this.setState({fechaDesde: moment(fechaProceso, "DD/MM/YYYY"), fechaHasta: moment(fechaProceso, "DD/MM/YYYY"),
            bodega_opt: bodega, bodega_sel: '01'})
        });
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0207');
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('02');

        this.setState({
            bodega_sel: null,
            linea_sel: null,
            articulo_desde_sel: null,
            articulo_hasta_sel: null,
            valorizado: false,
            fechaDesde: moment(fechaProceso, "DD/MM/YYYY"), 
            fechaHasta: moment(fechaProceso, "DD/MM/YYYY")
        });
    }

    impKardexPorArticulo(){
        var continuar = true;
        var error = "";
        var errorAnio = false;
        var idReporte = '';

        if(this.state.valorizado===true){
            idReporte = '20';
        }else{
            idReporte = '19';
        }

        //Validacion formato fecha
        if(this.state.fechaDesde){
            if(this.state.fechaDesde.isValid()===false){
                errorAnio = true;
                continuar = false;
                error=error+'- La fecha desde no es correcta.\n';
            }
        }else{
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha desde no se encuentra ingresada.\n';
        }

        if(this.state.fechaHasta){
            if(this.state.fechaHasta.isValid()===false){
                errorAnio = true;
                continuar = false;
                error=error+'- La fecha hasta no es correcta.\n';
            }
        }else{
            errorAnio = true;
            continuar = false;
            error=error+'- La fecha hasta no se encuentra ingresada.\n';
        }
            

        //Validacion FECHA DESDE > FECHA HASTA
        if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0 && errorAnio === false){
            continuar = false;
            error=error+'- La fecha desde debe ser menor a: '+formatearFechaMoment_a_String(this.state.fechaHasta)+'\n';
        }

        if(continuar === true){
            let parametros = '&rpt='+idReporte+'&param1='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)+'&param2='+formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)

            if(this.state.bodega_sel!==null){
                parametros = parametros+'&param3='+this.state.bodega_sel
            }

            if(this.state.articulo_desde_sel!==null){
                parametros = parametros+'&param4='+this.state.articulo_desde_sel.value
            }

            if(this.state.articulo_hasta_sel!==null){
                parametros = parametros+'&param5='+this.state.articulo_hasta_sel.value
            }

            if(this.state.linea_sel!==null){
                parametros = parametros+'&param6='+this.state.linea_sel.value
            }

            visualizarReporteEnPdf(parametros);
        }else{
            alert(error)
        }
    }

    cambiarValoresInput(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    render(){
        return (
            <ContenedorForm porc_ancho={50}>
            <HeaderForm>
                <TituloForm>Kardex por Artículo</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='8'>
                            <LabelForm>Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_arriba='15' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaEscogida)=>{this.setState({fechaDesde: fechaEscogida});}}/>
                        </ContainerCol>  
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <LabelForm>Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-4' margen_abajo='4'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaEscogida)=>{this.setState({fechaHasta: fechaEscogida});}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-3' margen_arriba='15' margen_abajo='4'>
                            <LabelForm>Bodega:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-5' margen_arriba='15' margen_abajo='4'>
                            <ReactSelect options={ this.state.bodega_opt } value={this.state.bodega_sel} func_onChange={(value)=>{this.setState({bodega_sel: value!==null?value.value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <LabelForm>Art. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-7' margen_abajo='4'>
                            <ReactSelectAsync value={this.state.articulo_desde_sel} func_loadOptions={this.getOptions_Articulos} func_onChange={(value)=>{this.setState({articulo_desde_sel: value!==null?value:null, articulo_hasta_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>                       
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <LabelForm>Art. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-7' margen_abajo='4'>
                            <ReactSelectAsync value={this.state.articulo_hasta_sel} func_loadOptions={this.getOptions_Articulos} func_onChange={(value)=>{this.setState({articulo_hasta_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <LabelForm>Marca:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-7' margen_abajo='4'>
                            <ReactSelectAsync value={this.state.linea_sel}  func_loadOptions={this.getOptions_Marcas} func_onChange={(value)=>{this.setState({linea_sel: value!==null?value:null})}}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-3' margen_abajo='4'>
                            <LabelForm><input type='checkbox' name='valorizado' checked={this.state.valorizado} 
                            onChange={this.cambiarValoresInput}/> Valorizado</LabelForm>
                        </ContainerCol>                      
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>                            
                                <button type='button' className='btn btn-info btn-sm' disabled={this.state.periodo===''||this.state.mes_sel===null?true:false} onClick={this.impKardexPorArticulo}><i className="fa fa-print fa-lg" aria-hidden="true"/> Imprimir</button>  
                                <button type="button" className='btn btn-sm'  onClick={this.limpiar}><i className="fa fa-trash-o fa-lg"></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {puntoFacturacionSel: state.ventas.ptoFacturacionSel,            
            permiso: state.sesion.valoresSesionForm.Permiso,
            usuario: state.sesion.valoresSesionForm.Usuario,
            IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,}
  });
  
  const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
  });
  
  export default connect (mapStateToProps, mapDispatchToProps)(FormInven07);